import { useIntl } from "react-intl";

const CustomizableWorkflows = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.CustomizableWorkflows.title",
            defaultMessage: "Customizable workflows"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.CustomizableWorkflows.body",
            defaultMessage:
                "Every team has their own style for moving work from ‘to do’ to ‘done.’ Create a custom workflow that helps your team work as efficiently as possible."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default CustomizableWorkflows;
